import { Input } from "antd";

const NodeNameInput = ({ data }) => (
  <Input
    value={data.nodeName || ""}
    onChange={(e) => data.onChange?.({ ...data, nodeName: e.target.value })}
    placeholder="Label this node…"
    size="small"
    variant="filled"
    style={{ marginBottom: 8, fontSize: 11, color: "#374151" }}
    className="nodrag"
    onPointerDown={(e) => e.stopPropagation()}
    onMouseDown={(e) => e.stopPropagation()}
  />
);

export default NodeNameInput;
